var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgChevronRight(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-450-820H990v2304H-450z"
  }), React.createElement("path", {
    d: "M-315-51H55V93h-370z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M27.663 21.03h.03l-.014-.015.015-.015h-.03L15.916 9.187l-2.792 2.777 9 9.051-9 9.052 2.792 2.776 11.746-11.812z"
  })));
}

export default SvgChevronRight;